<template>
    <c-dropdown-header as="div" class="bg-light rounded-top">
        <slot/>
    </c-dropdown-header>
</template>
<script setup>
import {CDropdownHeader} from "@coreui/vue/dist/esm/components/dropdown/index.js";
</script>
